import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox, VBox } from '../../../components/Box';
import { Card } from '../../../components/Card';
import { Row, Cell, List } from '../../../components/List';

import { VehicleAvatar } from '../../../components/VehicleAvatar/VehicleAvatarWeblogin';
import { KanbanProgressBar } from '../../KanbanBoards/components/ProgressBar';
import { VehicleStatusCard } from '../../Vehicles/components/CardStatus';
import { VehicleStatusLabel } from '../../Vehicles/components/VehicleStatusLabel';

import { getDate } from '../../Vehicles/helpers';
import { selectUserId, selectWork } from '../../Api/selectors';
import { selectUser } from '../../Users/selectors';
import { fetchUser } from '../../Users/actions';
import { getPropByName, getPropertyValueObjectByName } from '../../../utils/props';
import { REQUEST_USER } from '../../Users/constants';
import { Loader } from '../../../components/Loader';
import cn from 'classnames';
import styles from './WebloginVehicleInfoCard.module.css';
import { VehicleAvatarSlider } from '../../../components/VehicleAvatarSlider';
import env from '../../../env';
import { AppClientId } from '../../Shared/constants';


const Container = styled.div`
  font-size: 14px;
  h3 {
    font-size: 20px;
  }
  .type {
    color: #6c757d;
  }
  .regplate {
  }

  .secondary-info {
    white-space: nowrap;
    font-weight: 600;
    color: #6e6e6e;

    
  }
  .secondary-info-list {
    color: #6e6e6e;
    font-weight: 600;
    @media (max-width: 768px) {
      margin-bottom: 16px;
    }
  }
  .info-card {
    background-color: var(--color-new-white);
    box-shadow: none;
    min-width: 260px;
    width: 100%;
  }
`;

const STATE = {};
/* eslint-disable react/prefer-stateless-function */
class WebloginVehicleInfoCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState) {}

  getDaysInStock(vehicle) {
   
    if (env.clientId !== AppClientId.HOOIKAMMER) {
        const mSec = Date.now() - new Date(vehicle['createdAt']);
        let days = mSec / 86400000;
        return Math.floor(days);
    } else {
      console.log('vehicle', vehicle.HOOI_inslag_done_date);
        const HOOI_inslag_done_date = vehicle.HOOI_inslag_done_date
            ? new Date(vehicle.HOOI_inslag_done_date)
            : new Date().toISOString();
        const HOOI_uitslag_done_date = vehicle.HOOI_uitslag_done_date
            ? new Date(vehicle.HOOI_uitslag_done_date)
            : new Date().toISOString();
        let days = '-';
        
        if (vehicle.HOOI_inslag_done_date != null) {
          
            days = Math.floor((new Date(HOOI_uitslag_done_date) - new Date(HOOI_inslag_done_date) + 86400000) / 86400000);
        }
        return days;
    }
}


  get statusUpdatedAt() {
    const date = getPropertyValueObjectByName(this.props.vehicle, 'status')?.updatedAt;
    const parsedDate = getDate(date, true);
    return parsedDate;
  }

  get userChangedStatus() {
    let name = this.state.user ? getPropByName(this.state.user, 'name') : this.props.changedStatusUser?.name || '';

    let surname = this.state.user ? getPropByName(this.state.user, 'surname') : this.props.changedStatusUser?.surname || '';
    return `${name} ${surname}`;
  }

  get statusRemark() {
    if (!this.props.vehicle?.status_remark) return '';

    return `${this.props.vehicle?.status_remark}`;
  }

  render() {
    const vehicle = this.props.vehicle;
    {
      var weblogin = '0';
      vehicle?.HOOI_uitslag_done &&(
        weblogin= '1'  )
      
      !vehicle?.HOOI_inslag_done_date && (
        weblogin= '2'  
      )

      vehicle?.HOOI_inslag_done_date && !vehicle?.HOOI_uitslag_done_date &&(
        weblogin= '3'  
      )
      
      vehicle?.HOOI_uitslag_done && vehicle?.outgoing_invoice_finalized == '1' &&(
        weblogin= '4'  
      )

      !vehicle?.HOOI_uitslag_done && vehicle?.outgoing_invoice_finalized == '1' &&(
        weblogin= '5'  
      )

    } 
    console.log('vehicle?.regplate', vehicle?.regplate);
    return (
      <Container width={window.innerWidth} className={styles.container}>
        <Card className={cn('vehicle-info-card info-card info', styles.card)}>
          <div className={cn("row", styles.row)}>
            <div className={cn('col', styles.colAvatar)}>
            <VehicleAvatar vehicle={vehicle} />
                        </div>

            <div className={cn('col', styles.colContainer)}>

              <HBox vCenter left>
                <VBox>
                  <div className={styles.brand}>
                    <h3>
                      {vehicle.brand_name} {vehicle.model_name}
                    </h3>
                  </div>
                  <div className={styles.model}>{vehicle?.model_info}</div>

                  <div className="type">{vehicle?.type}</div>

                  <div className={cn('row', styles.info)}>
                    <div className="col">
                      <div className={styles.topInfo}>{this.lbl('vehicle.property.regplate')}</div>
                      <span className="secondary-info">{vehicle?.regplate}</span>
                    </div>
                    <div className="col">
                      <div className={styles.topInfo}>{this.lbl('vehicle.property.mileage')}</div>
                      <span className="secondary-info">{vehicle?.mileage || '-'}</span>
                    </div>
                    <div className="col">
                      <div className={styles.topInfo}>{this.lbl('vehicle.property.vehicle.property.date_first_allowance')}</div>
                      <span className="secondary-info">{getDate(vehicle?.date_first_allowance)}</span>
                    </div>
                  </div>
                </VBox>
              </HBox>
              
              
              <div className={styles.label}>
              {env.clientId !== AppClientId.HOOIKAMMER || (vehicle.status === '5' || vehicle.status === '6') ? (
                  <VehicleStatusLabel key={vehicle.id} status={vehicle.status}>
                      {this.lbl('vehicle.property.status.' + (vehicle.status || 0))}
                  </VehicleStatusLabel>
              ) : (   
                  <VehicleStatusLabel key={vehicle.id} status={weblogin}>
                      {this.lbl('vehicle.property.status.weblogin.' + (weblogin || 0))}
                  </VehicleStatusLabel>
              )}

              </div>

              {vehicle.active_claim == '1' ? (
                <div style={{ display: 'inline-flex', alignItems: 'center' }}>
                  <img
                    style={{ cursor: 'pointer' }}
                    src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/3b/OOjs_UI_icon_alert-warning.svg/1024px-OOjs_UI_icon_alert-warning.svg.png"
                    width="18"
                  />
                  <span style={{ marginLeft: '5px' }}>Claim op dit voertuig!</span>
                </div>
              ) : (
                <img
                  style={{ cursor: 'pointer', opacity: '0.1' }}
                  src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/3b/OOjs_UI_icon_alert-warning.svg/1024px-OOjs_UI_icon_alert-warning.svg.png"
                  width="18"
                />
              )}

              <List className="secondary-info-list">
                <Row key={'stage_days'}>
                  <Cell>{this.lbl(`vehicle.property.days_is_stock`)}</Cell>
                  <Cell>{this.getDaysInStock(vehicle)}</Cell>
                </Row>
                {vehicle['date_expected'] && (
                  <Row key={'add_to_order'}>
                    <Cell>{this.lbl(`vehicle.property.date_expected`)}</Cell>
                    <Cell>{getDate(vehicle['date_expected'])}</Cell>
                  </Row>
                )}
              </List>
            </div>
          </div>
        </Card>
      </Container>
    );
  }
}

WebloginVehicleInfoCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    loggedInUserId: selectUserId(),
    changedStatusUser: selectUser(ownProps.vehicle?.user_changed_status),
    work: selectWork(REQUEST_USER),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch(id, callback) {
      dispatch(fetchUser(id, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const WebloginVehicleInfoCard = compose(withConnect, withRouter)(WebloginVehicleInfoCardComp);
